module.exports = __webpack_public_path__ + "img/message.e3249571.svg";